<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div
          id="performance"
          class="container-fluid overflow-auto pb-4 menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <nav class="navbar navbar-expand-lg bg-info text-white">
            <span>
              <b>DashBoard</b>
            </span>
          </nav>

          <div
            class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
          >
            <div
              class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
            >
              <label for="select dashbord">Select Dashboard Type</label>
            </div>
            <div
              class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
            >
              <select class="form-control input-sm">
                <option value="All">All</option>
              </select>
            </div>
          </div>
          <br />

          <div>
            <iframe :src="dashboardpage" width="100%" height="980px"></iframe>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import dashboard from '../js/http-dashboards.js'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      dashboardpage: undefined
    }
  },

  methods: {
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#performance').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },

  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
    dashboard.get('/barChart/collections').then(response => {
      this.dashboardpage = response.config.url
      console.log(this.dashboardpage)
    })
  },
  mounted () {
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
body {
  margin: 0; /* Reset default margin */
}
iframe {
  display: block; /* iframes are inline by default */
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
